




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";

import dayjs from "dayjs";

class PageApiLogsRequest extends PageRequest {
  userId: string = "";
  startTime: any;
  endTime: any;
  appid: string = "";
}

@Component({
  components: {},
})
export default class ApiLogsVM extends AbpBase {
  pageRequest: PageApiLogsRequest = new PageApiLogsRequest();

  get list() {
    return this.$store.state.apiLogs.list;
  }

  get loading() {
    return this.$store.state.apiLogs.loading;
  }

  pageChange(page: number) {
    this.$store.commit("apiLogs/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("apiLogs/setPageSize", pagesize);
    this.getpage();
  }

  async getpage() {
    if (this.pageRequest.startTime) {
      this.pageRequest.startTime = dayjs(this.pageRequest.startTime).format(
        "YYYY-MM-DD"
      );
    }
    if (this.pageRequest.endTime) {
      this.pageRequest.endTime = dayjs(this.pageRequest.endTime).format(
        "YYYY-MM-DD 23:59:59"
      );
    }
    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "apiLogs/getAll",
      data: this.pageRequest,
    });
  }

  get pageSize() {
    return this.$store.state.apiLogs.pageSize;
  }

  get totalCount() {
    return this.$store.state.apiLogs.totalCount;
  }

  get currentPage() {
    return this.$store.state.apiLogs.currentPage;
  }

  columns = [
    {
      title: this.L("ID"),
      key: "id",
    },
    {
      title: this.L("抽奖人"),
      key: "userId",
    },
    {
      title: this.L("应用ID"),
      key: "appId",
    },
    {
      title: this.L("礼包代码"),
      key: "requestData",
    },
    {
      title: this.L("奖品代码"),
      key: "responseData",
    },
    {
      title: this.L("开始时间"),
      key: "createTime",
    },
    {
      title: this.L("结束时间"),
      key: "endTime",
    },
  ];

  async created() {
    await this.getpage();
  }
}
